var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWatchicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.25,
    x: 2,
    y: 4,
    width: 20,
    height: 16,
    rx: 3,
    fill: "#FF23C1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.035 6.626a.875.875 0 0 1 .82.684l1.314 5.916 1-3.003a.875.875 0 0 1 1.45-.342l1.243 1.244H19a.875.875 0 0 1 0 1.75h-2.5a.875.875 0 0 1-.619-.256l-.499-.5-1.552 4.658a.875.875 0 0 1-1.684-.087l-1.283-5.77-1.027 3.337a.875.875 0 0 1-1.455.362l-1.743-1.744H5a.875.875 0 1 1 0-1.75h2c.232 0 .455.092.619.256l.972.973 1.573-5.111a.875.875 0 0 1 .87-.617Z",
    fill: "#FF23C1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchicon);
export default __webpack_public_path__ + "static/media/watch.icon.6f9a2a7b8d870edcd3e166bb358dbb41.svg";
export { ForwardRef as ReactComponent };